import React, { createContext, useContext, useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { bridge } from '../../util/webview/bridge'

const WebViewContext = createContext(null)

export function useWebView() {
  const context = useContext(WebViewContext)
  if (!context) {
    throw new Error('useWebView must be used within a WebViewProvider')
  }
  return context
}

export function WebViewProvider({ children }) {
  const [isWebView, setIsWebView] = useState(false)

  useEffect(() => {
    setIsWebView(bridge?.isWebView() ?? false)
  }, [])

  const onPasswordChanged = success => bridge?.onPasswordChanged(success)
  const onPasswordChangeCancel = () => bridge?.onPasswordChangeCancel()
  const showMessage = (type, message) => bridge?.showMessage(type, message)
  const goBack = () => bridge?.goBack()
  const close = () => bridge?.close()

  const value = {
    isWebView,
    onPasswordChanged,
    onPasswordChangeCancel,
    showMessage,
    goBack,
    close,
  }

  return <WebViewContext.Provider value={value}>{children}</WebViewContext.Provider>
}

WebViewProvider.propTypes = {
  children: PropTypes.node.isRequired,
}
